module.exports = __webpack_public_path__ + "static/media/apple.a844684e.svg";